import type { CatalogEdition } from "@/lib/customy/catalog-contract";
import { t, type Locale } from "@/lib/i18n";

/** Which edition the page shows: an Atlas version (verified pipeline) or the editorial snapshot. */
export function CatalogEditionNotice({ edition, locale = "es" }: { edition: CatalogEdition; locale?: Locale }) {
  const copy = t(locale).catalog;
  const sep = <span className="vc-edition-sep" aria-hidden="true">·</span>;
  return <p className="vc-edition" role="status">
    <span className={edition.origin === "atlas" ? "ui-badge ui-badge-data" : "ui-badge"}>{edition.origin === "atlas" ? copy.atlasVersion(edition.version) : copy.editorialEdition}</span>
    <span>{copy.reviewedOn(edition.reviewedAt)}</span>{sep}<span>{copy.notRealtime}</span>
    {edition.stale && <>{sep}<span className="ui-badge ui-badge-warn">{copy.staleEdition(edition.stale.ageSeconds)}</span></>}
    {edition.contentHash && <>{sep}<span title={edition.contentHash}>{copy.evidence} {edition.contentHash.slice(0, 12)}</span></>}
  </p>;
}
